// extracted by mini-css-extract-plugin
module.exports = {"title":"MobileWarningModal_title__2gf0q","subTitle":"MobileWarningModal_subTitle__1qNAD","closeButton":"MobileWarningModal_closeButton__xOvyK"};